import * as React from 'react';
import Grid, { GridColumn } from '@telia-front/grid';
import Heading from '@telia-front/heading';
import Icon from '@telia-front/icon';
import { TableCell, TableRow } from '@telia-front/table';
import { TableCollapse, TableCollapseTrigger } from '@telia-front/table-collapse';
import { TvComparisonContext } from './index';
import ChannelPriceTableCell from './channel-price-table-cell';
import MobileTableHeader from './mobile-table-header';
const MobileViewerSlots = (props) => {
    const { viewerSlots, packets, initialHeadingLevel = 2 } = props;
    const { showMoreLabel, showLessLabel } = React.useContext(TvComparisonContext);
    const renderViewerSlotRow = (slot) => {
        return (React.createElement(React.Fragment, { key: slot.id },
            React.createElement(TableRow, { background: "neutral-1", className: "tv-comparison__row" },
                React.createElement(TableCell, { colSpan: 3, className: "text tv-comparison__name-cell" },
                    React.createElement(Grid, { noWrap: true, align: ['middle-xs'] },
                        slot.icon && (React.createElement(GridColumn, { width: ['min'] },
                            React.createElement(Icon, { size: "md", modifiers: slot.icon, className: "visible" }))),
                        React.createElement(GridColumn, { width: ['max'] },
                            React.createElement("p", { className: "h5 text-bold" }, slot.title)),
                        slot.description && (React.createElement(GridColumn, { width: ['min'] }, showMoreLabel && (React.createElement(TableCollapseTrigger, { text: showMoreLabel, activeText: showLessLabel, url: `#${slot.id}`, iconRight: "#arrow-down", link: true }))))))),
            slot.description && (React.createElement(TableRow, { id: slot.id, collapsible: true, background: "neutral-1", className: "tv-comparison__row" },
                React.createElement(TableCell, { colSpan: 3, className: "text tv-comparison__info-cell" },
                    React.createElement("div", null, slot.description)))),
            React.createElement(TableRow, { background: "neutral-1", className: "tv-comparison__row tv-comparison__price-row" },
                slot.packetPrices &&
                    slot.packetPrices.map((price, index) => React.createElement(ChannelPriceTableCell, { price: price, width: 4, key: index, variant: "secondary", alignCenter: true })),
                slot.packetInfos &&
                    slot.packetInfos.map((info, index) => {
                        return (React.createElement(TableCell, { width: 4, className: "text-center", valign: "middle", key: index }, info));
                    }))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Heading, { level: initialHeadingLevel, className: "h4 tv-comparison__header" },
            viewerSlots.title,
            " "),
        React.createElement(TableCollapse, { bordered: true, className: "tv-comparison__table" },
            React.createElement("thead", { className: "sr-only" },
                React.createElement(MobileTableHeader, { packets: packets })),
            React.createElement("tbody", null, viewerSlots.slots.map(renderViewerSlotRow)))));
};
export default MobileViewerSlots;
